// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2aw7T","right":"styles_right__Loer0"};